import { Injectable, inject, DOCUMENT } from '@angular/core';

import { environment } from '../../environments/environment';

declare const grecaptcha: {
  ready(callback: () => void): void;
  execute(siteKey: string, options: { action: string }): Promise<string>;
};

@Injectable({ providedIn: 'root' })
export class RecaptchaService {

  private readonly siteKey = environment.captchaSiteKey;
  private scriptLoaded = false;
  private document = inject(DOCUMENT);

  private loadScript(): Promise<void> {
    if (this.scriptLoaded || !this.siteKey) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const script = this.document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));
      this.document.head.appendChild(script);
    });
  }

  async getToken(action: string): Promise<string | null> {
    if (!this.siteKey) {
      return null;
    }
    await this.loadScript();
    return new Promise<string>((resolve, reject) => {
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(this.siteKey, { action });
          resolve(token);
        } catch (err) {
          reject(err);
        }
      });
    });
  }
}
